import PageMetaLoader from '../components/PageMetaLoader';
import styled from 'styled-components';

const demoLinks = [
  {
    title: 'Front Store Demo',
    description: 'Explore the customer-facing storefront experience and product browsing flow.',
    url: 'https://store-demo.akas.co',
  },
  {
    title: 'Store Admin Demo',
    description: 'Review the management dashboard for products, and day-to-day store tasks.',
    url: 'https://store-demo.akas.co/dashboard',
    username: 'demo',
    password: 'demo123',
  },
  {
    title: 'HR System Demo',
    description: 'Review the fully functional HR system.',
    url: 'https://hrdemo2.akas.co',
    username: 'demo',
    password: 'demo123',
  },
  {
    title: 'Clinic Demo',
    description: 'Review the clinic management system dashboard for operations, and day-to-day clinic tasks.',
    url: 'https://clinic-demo.akas.co',
    username: 'demo',
    password: 'demo123',
  }
];

const DemoPage = () => {
  return (
    <>
    <PageMetaLoader pageUrl="demo" />
    <PageSection>
      <div className="container">
        <Panel>
          <HeaderBlock>
            <Eyebrow>Demo Environment</Eyebrow>
            <Title>Full Featured Demo</Title>
            <Description>
              Thank you for your interest in our demo. Please use the links below to preview both the
              front store and the admin experience.
            </Description>
          </HeaderBlock>

          <CardsGrid>
            {demoLinks.map((demo) => (
              <DemoCard key={demo.title}>
                <CardTitle>{demo.title}</CardTitle>
                <CardText>{demo.description}</CardText>
                {demo.username && <div>Username: {demo.username}</div>}
                {demo.password && <div className='mb-3'>Password: {demo.password}</div>}
                <DemoLink href={demo.url} target="_blank" rel="noopener noreferrer">
                  Open Demo
                </DemoLink>
              </DemoCard>
            ))}
          </CardsGrid>
        </Panel>
      </div>
    </PageSection>
    </>
  );
};

const PageSection = styled.main`
  padding: 5.5rem 0 4.5rem;
  background: linear-gradient(180deg, #f5fbff 0%, #ffffff 70%);
`;

const Panel = styled.div`
  border: 1px solid rgba(0, 142, 204, 0.15);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.05);
  padding: 2rem;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

const HeaderBlock = styled.div`
  max-width: 760px;
  margin-bottom: 1.5rem;
`;

const Eyebrow = styled.span`
  display: inline-block;
  padding: 0.3rem 0.85rem;
  background: var(--primary-light);
  color: var(--primary-color);
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: 0.9rem;
`;

const Title = styled.h1`
  font-size: 2rem;
  color: #111;
  margin-bottom: 0.8rem;

  @media (max-width: 576px) {
    font-size: 1.6rem;
  }
`;

const Description = styled.p`
  margin: 0;
  color: #4a5560;
  line-height: 1.7;
`;

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const DemoCard = styled.article`
  border: 1px solid #e7edf2;
  border-radius: 12px;
  padding: 1.2rem;
  background: #fff;
`;

const CardTitle = styled.h2`
  font-size: 1.15rem;
  margin-bottom: 0.55rem;
  color: #19202a;
`;

const CardText = styled.p`
  margin: 0 0 1rem;
  color: #5d6773;
  line-height: 1.65;
`;

const DemoLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.58rem 1rem;
  background: var(--primary-color);
  color: #fff;
  border-radius: 8px;
  font-weight: 600;
  transition: background-color 0.2s ease, transform 0.2s ease;

  &:hover {
    background: #0077ab;
    transform: translateY(-1px);
  }
`;

export default DemoPage;